/*
,------.                                    ,--.          ,--.      ,--------.    ,------.            ,--.           
|  .-.  \,--. ,--.,--,--,  ,--,--.,--,--,--.`--' ,---.    |  | ,---.'--.  .--'    |  .-.  \  ,--,--.,-'  '-. ,--,--. 
|  |  \  :\  '  / |      \' ,-.  ||        |,--.| .--'    |  || .-. |  |  |       |  |  \  :' ,-.  |'-.  .-'' ,-.  | 
|  '--'  / \   '  |  ||  |\ '-'  ||  |  |  ||  |\ `--.    |  |' '-' '  |  |       |  '--'  /\ '-'  |  |  |  \ '-'  | 
`-------'.-'  /   `--''--' `--`--'`--`--`--'`--' `---'    `--' `---'   `--'       `-------'  `--`--'  `--'   `--`--' 
         `---'                                                                                                      
*/
import { VisionApplication } from '../../application';
import { PublishTopic } from '../../events';
import { VisionMapGeofence } from '../../map/geofence';
import { IPubSubSubscriber } from '../../pubsub';
import { GeofenceDTO, GeofenceService } from '../../service/geofence.service';
import { VisionGeofenceWindow } from '../../window/geofence.window';
import { VisionAVLTab2 } from './avl_tab';
import { VisionGeofenceReportWindow } from './report_geofence_window';

/** Handles the Geofence Tab from the AVL Tab.
 *
 */
export class GeofenceTree implements IPubSubSubscriber {
    // UI Elements
    toolbar!: dhtmlXToolbarObject;
    geofenceList!: dhtmlXGridObject;

    parent: VisionAVLTab2;
    service: GeofenceService;
    geofences!: Map<string, VisionMapGeofence>;
    geofenceData!: Map<string, GeofenceDTO>;

    identifier = '2b7bfdce-2982-4763-a1b0-762c153dea14';

    constructor(parent: VisionAVLTab2) {
        this.parent = parent;
        this.service = VisionApplication.getInstance().geofenceService;

        this.geofenceData = new Map<string, GeofenceDTO>();
        this.geofences = new Map<string, VisionMapGeofence>();
        VisionApplication.getInstance().pubsub.subscribe(PublishTopic.GEOFENCES_CHANGED, this);

        this.buildUI();
        this.buildHandlers();
        this.populateGeofences();
    }

    private buildUI(): void {
        this.toolbar = this.parent.tabbar.cells('GEOFENCE').attachToolbar();
        this.geofenceList = this.parent.tabbar.cells('GEOFENCE').attachGrid();
        this.geofenceList.setHeader('Show,Name,Description', '', []);
        this.geofenceList.setImagesPath('css/imgs/');
        this.geofenceList.setColTypes('ch,ro,ro');
        this.geofenceList.init();

        this.toolbar.addButton('manage', 0, 'Manage', '/icons/gears.png', '/icons/pdf.png');
        this.toolbar.addButton('reports', 1, 'Reports', '/icons/pdf.png', '/icons/pdf.png');
    }

    private buildHandlers(): void {
        this.toolbar.attachEvent('onClick', (id) => {
            switch (id) {
                case 'manage': {
                    const window = new VisionGeofenceWindow(VisionApplication.getInstance().windowManager);
                    window.show();
                    break;
                }
                case 'reports': {
                    const geowindow = new VisionGeofenceReportWindow(VisionApplication.getInstance().windowManager);
                    geowindow.show();
                    break;
                }
            }
        });
        this.geofenceList.attachEvent('onCheckbox', (rid, _cid, state) => {
            this.toggleGeofence(rid, state);
        });

        this.geofenceList.attachEvent('onRowSelect', (rid, _cid) => {
            this.zoomToGeofence(rid);
        });
    }

    private zoomToGeofence(id: string) {
        const geo = this.geofences.get(id);
        if (geo) {
            this.parent.mapPanel.map.map.fitBounds(geo.bounds);
        }
    }

    private toggleGeofence(id: string, state: boolean) {
        let geo = this.geofences.get(id);

        if (geo == undefined) {
            geo = new VisionMapGeofence(this.parent.mapPanel.map);
            const data = this.geofenceData.get(id);
            if (data) {
                geo.createGeofence(data.geometry, data.colour, 1);
                this.geofences.set(id, geo);
            }
        }

        if (state == false) {
            geo.polygon.setMap(null);
        } else {
            geo.polygon.setMap(this.parent.mapPanel.map.map);
            this.parent.mapPanel.map.map.fitBounds(geo.bounds);
        }
    }

    private populateGeofences(): void {
        this.geofences.forEach((vgm) => {
            vgm.polygon.setMap(null);
        });
        this.geofences.clear();
        this.geofenceList.clearAll(false);
        this.geofenceData.clear();

        const request = this.service.cachedFetchData();
        request.then((data) => {
            data.forEach((geofence) => {
                this.geofenceList.addRow(geofence.id.id, [0, geofence.id.name, 'N/A'], 0, '', '', false);
                this.geofenceData.set(geofence.id.id, geofence);
            });
        });
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    notify(msg: string, _data?: any): void {
        switch (msg) {
            case PublishTopic.GEOFENCES_CHANGED: {
                this.populateGeofences();
                break;
            }
        }
    }
}
